import React from 'react';

// Royal Tower Logo - SVG vector logo
export default function Logo({ size = 45, style = {} }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      style={{ borderRadius: 8, ...style }}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background */}
      <rect width="100" height="100" rx="10" fill="#1a1f36" />
      {/* Tower structure */}
      <rect x="38" y="20" width="24" height="60" fill="#63b3ed" rx="2" />
      {/* Tower top - crenellations */}
      <rect x="34" y="15" width="8" height="10" fill="#90cdf4" rx="1" />
      <rect x="46" y="12" width="8" height="13" fill="#90cdf4" rx="1" />
      <rect x="58" y="15" width="8" height="10" fill="#90cdf4" rx="1" />
      {/* Windows */}
      <rect x="44" y="30" width="12" height="8" fill="#1a365d" rx="1" />
      <rect x="44" y="44" width="12" height="8" fill="#1a365d" rx="1" />
      <rect x="44" y="58" width="12" height="8" fill="#1a365d" rx="1" />
      {/* Base */}
      <rect x="25" y="78" width="50" height="6" fill="#4a5568" rx="2" />
      {/* Door */}
      <rect x="44" y="66" width="12" height="14" fill="#2b4c7e" rx="1" />
      {/* Stars */}
      <circle cx="22" cy="25" r="2" fill="#fbd38d" />
      <circle cx="78" cy="30" r="2" fill="#fbd38d" />
      <circle cx="18" cy="50" r="1.5" fill="#fbd38d" />
      <circle cx="82" cy="55" r="1.5" fill="#fbd38d" />
    </svg>
  );
}
